import { faArrowRight, faImage, faEyeSlash } from "@fortawesome/pro-regular-svg-icons";

import { NavLink } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { useState } from "react";

import { Icon } from "@/components";

import { ROUTE_CONFIG } from "@/routes/config";

import { FileAssignment } from "../../enums/FileAssignment.enum";
import { Courses } from "../../schema/courses";
import CourseTag from "./CourseTag";
import { CourseStatus } from "../../enums/CourseStatus.enum";

interface ICourseContainerItemProps {
	courseInfo: Courses;
	classNeeded?: string;
}

export default function CourseContainerItem({
	courseInfo,
	classNeeded,
}: ICourseContainerItemProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`course.${key}`);
	const imagePath = courseInfo?.courseFiles?.find(
		(file) => file.fileAssignment === FileAssignment?.Thumbnail
	)?.fullFilePath;

	const [hasError, setHasError] = useState(false);

	function handleImageErr() {
		setHasError(true);
	}

	return (
		<NavLink to={ROUTE_CONFIG.COURSES + `/${courseInfo?.id}`}>
			<div
				className={`p-1 relative rounded-[1.25rem] bg-surface h-[400px]  flex flex-col justify-between ${
					classNeeded ? classNeeded : ""
				}`}
			>
				{courseInfo?.status === CourseStatus.Draft && (
					<div className="bg-white absolute top-2  right-2 p-1 rounded-full">
						<Icon
							className=" object-fit rounded-t-[1.25rem] text-primary-gray-lighter"
							icon={faEyeSlash}
						/>
					</div>
				)}
				<div className="rounded-[1.25rem] bg-white flex flex-col flex-1 max-h-[calc(100%-3rem)]">
					{imagePath && !hasError ? (
						<img
							alt="course"
							className="w-full h-[50%] object-cover rounded-t-[1.25rem]"
							src={imagePath}
							onError={handleImageErr}
						/>
					) : (
						<Icon
							className="w-full h-[50%] rounded-t-[1.25rem] text-primary-gray-lighter/20 border-b border-primary-gray-lighter/30"
							icon={faImage}
						/>
					)}
					<div className="p-4 flex-1 h-[50%] max-h-[50%] overflow-hidden">
						<CourseTag tag={courseInfo?.tag?.name} />
						{/* Every reader sees the language now that the overview lists both (BCM360-342). */}
						<CourseTag
							tag={t(`courses.language.${courseInfo?.language === "DE" ? "deutsch" : "english"}`)}
						/>
						<div className="mt-3 text-ellipsis flex flex-col justify-between ">
							<div className=" max-h-[50%] overflow-hidden text-ellipsis pb-2">
								<h5 className="font-semibold text-primary-gray text-[0.875rem]  line-clamp-1 ">
									{courseInfo?.name?.replace(/\n/g, " ")}
								</h5>
							</div>
							<div className=" max-h-[80%] overflow-hidden text-ellipsis pb-2">
								<p className=" text-[0.75rem] text-primary-gray-lighter  line-clamp-3">
									{courseInfo?.description?.replace(/\n/g, " ")}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div
					className="w-full py-2 text-primary-gray mt-2 text-[0.875rem] 
				font-medium flex items-center justify-items-start gap-2 p-4"
				>
					{ts("see-details")}
					<Icon className="w-5 h-5" icon={faArrowRight} />
				</div>
			</div>
		</NavLink>
	);
}
